import React, { Fragment, useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { changePaymentProblematicStatus } from "services"
import { Button, ConfirmationModal } from "components"
import classes from "./OrderDetailsProblematicPaymentButton.module.scss"

const OrderDetailsProblematicPaymentButton = props => {
  const {
    order,
    setOrders,
    setOpenOrderDetailsSidebar
  } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)

  const unmount = useRef(false)

  const handlePress = async () => {
    setSending(true)

    try {
      await changePaymentProblematicStatus(
        order._id,
        { isPaymentProblematic: true }
      )

      if (unmount.current) return

      setOrders(prev =>
        prev.map(o =>
          o._id === order._id
            ? { ...o, isPaymentProblematic: true }
            : o
        )
      )

      setOpenOrderDetailsSidebar(false)

      toast.success(t("عدم_تایید_پرداخت_انجام_شد"))
    } catch (err) {
      console.log(err)

      toast.error(t("رد_پرداخت_انجام_نشد"))

      if (unmount.current) return

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      <Button
        fullWidth
        className={classes["button"]}
        color="danger"
        onClick={() => setOpenConfirmationModal(true)}
      >
        {t("عدم_تایید_پرداخت")}
      </Button>

      <ConfirmationModal
        title={t("آیا_می_خواهید_پرداخت_این_سفارش_را_رد_کنید")}
        show={openConfirmationModal}
        onConfirm={handlePress}
        onHide={() => setOpenConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default OrderDetailsProblematicPaymentButton